'use strict';

var v8n = require('v8n');
require('dequal');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var v8n__default = /*#__PURE__*/_interopDefault(v8n);

const clamp = (x, min, max) => x > max ? max : x < min ? min : x;
const pad = (x, pad) => String(x).padStart(pad, '0');
const ceil = v => Math.sign(v) * Math.ceil(Math.abs(v));
const log10 = Math.log(10);
function getStep(number) {
  let n = Math.abs(+String(number).replace('.', '')); //remove decimal and make positive

  if (n === 0) return 0.01;

  while (n !== 0 && n % 10 === 0) n /= 10; //kill the 0s at the end of n


  const significantDigits = Math.floor(Math.log(n) / log10) + 1;
  const numberLog = Math.floor(Math.log10(Math.abs(number)));
  const step = Math.pow(10, numberLog - significantDigits);
  return Math.max(step / 10, 0.001);
}
const range = (v, min, max) => (v - min) / (max - min);
const invertedRange = (p, min, max) => p * (max - min) + min;

function pick(object, keys) {
  return keys.reduce((obj, key) => {
    if (object && object.hasOwnProperty(key)) {
      obj[key] = object[key];
    }

    return obj;
  }, {});
}
function orderKeys(obj, keys) {
  return keys.reduce((acc, k) => ({ ...acc,
    [k]: obj[k]
  }), {});
}
function mapArrayToKeys(value, keys) {
  if (!Array.isArray(value)) return value; // in if value is already an object

  return value.reduce((acc, v, i) => ({ ...acc,
    [keys[i]]: v
  }), {});
}

(function (LevaErrors) {
  LevaErrors[LevaErrors["UNSUPPORTED_INPUT"] = 0] = "UNSUPPORTED_INPUT";
  LevaErrors[LevaErrors["UNKNOWN_INPUT"] = 1] = "UNKNOWN_INPUT";
  LevaErrors[LevaErrors["DUPLICATE_KEYS"] = 2] = "DUPLICATE_KEYS";
  LevaErrors[LevaErrors["ALREADY_REGISTERED_TYPE"] = 3] = "ALREADY_REGISTERED_TYPE";
  LevaErrors[LevaErrors["CLIPBOARD_ERROR"] = 4] = "CLIPBOARD_ERROR";
  LevaErrors[LevaErrors["THEME_ERROR"] = 5] = "THEME_ERROR";
})(exports.LevaErrors || (exports.LevaErrors = {}));

const ErrorList = {
  [exports.LevaErrors.UNSUPPORTED_INPUT]: (type, path) => [`you've passed a ${type} input at path "${path}" but we don't support it yet.`],
  [exports.LevaErrors.UNKNOWN_INPUT]: (path, value) => [`input at path "${path}" is not recognized.`, value],
  [exports.LevaErrors.DUPLICATE_KEYS]: (key, path) => [`Key ${key} already exists at path "${path}" in your hook. Even nested keys need to be unique.`],
  [exports.LevaErrors.ALREADY_REGISTERED_TYPE]: type => [`Type ${type} has already been registered. You can't register a component with the same type.`],
  [exports.LevaErrors.CLIPBOARD_ERROR]: value => [`Error copying the value`, value],
  [exports.LevaErrors.THEME_ERROR]: (category, key) => [`Error accessing the theme "${category}.${key}" value`]
};

function _log(fn, errorType, ...args) {
  //@ts-expect-error
  const [message, ...rest] = ErrorList[errorType](...args);
  console[fn]('LEVA: ' + message, ...rest);
} // @ts-expect-error


const warn = _log.bind(null, 'warn'); // @ts-expect-error

const log = _log.bind(null, 'log');

/**
 * Types exposed through the public API
 */

(function (SpecialInputTypes) {
  SpecialInputTypes["SEPARATOR"] = "SEPARATOR";
  SpecialInputTypes["BUTTON"] = "BUTTON";
  SpecialInputTypes["MONITOR"] = "MONITOR";
  SpecialInputTypes["FOLDER"] = "FOLDER";
})(exports.SpecialInputTypes || (exports.SpecialInputTypes = {}));

const debounce = (callback, wait, immediate = false) => {
  let timeout = 0;
  return function () {
    const args = arguments;
    const callNow = immediate && !timeout; // @ts-expect-error

    const next = () => callback.apply(this, args);

    window.clearTimeout(timeout);
    timeout = window.setTimeout(next, wait);
    if (callNow) next();
  };
};

const schema = o => v8n__default['default']().number().test(o);
const validate = v => v !== '' && !isNaN(Number(v));
const format = (v, {
  pad = 0
}) => Number(v).toFixed(pad);
const sanitize = (v, {
  min = -Infinity,
  max = Infinity
} = {}) => clamp(Number(v), min, max);
const normalize = ({
  value,
  ...settings
}) => {
  const {
    min,
    max
  } = settings;
  let step = settings.step;
  let padStep = getStep(value);

  if (!step) {
    if (Number.isFinite(min)) {
      if (Number.isFinite(max)) step = +(Math.abs(max - min) / 400).toPrecision(1);else step = +(Math.abs(value - min) / 400).toPrecision(1);
    } else if (Number.isFinite(max)) step = +(Math.abs(max - value) / 400).toPrecision(1);else step = padStep;
  }

  const pad = clamp(Math.log10(1 / padStep), 0, 2);
  return {
    value,
    settings: {
      initialValue: value,
      step,
      pad,
      min: -Infinity,
      max: Infinity,
      ...settings
    }
  };
};
const sanitizeStep = (v, {
  step,
  initialValue
}) => {
  const steps = Math.round((v - initialValue) / step);
  return initialValue + steps * step;
};

var props = /*#__PURE__*/Object.freeze({
  __proto__: null,
  schema: schema,
  validate: validate,
  format: format,
  sanitize: sanitize,
  normalize: normalize,
  sanitizeStep: sanitizeStep
});

const normalizeKeyedNumberInput = (value, settings) => {
  const _settings = {};
  Object.entries(value).forEach(([key, v]) => {
    _settings[key] = normalize({
      value: v,
      ...settings[key]
    }).settings;
  });
  return {
    value,
    settings: _settings
  };
};

// SCHEMA
const number = v8n__default['default']().number();
function getVectorSchema(keys) {
  // prettier-ignore
  const VectorArray = v8n__default['default']().array().length(keys.length).every.number();
  const pointObj = v8n__default['default']().schema(keys.reduce((acc, k) => ({ ...acc,
    [k]: number
  }), {}));
  return o => v8n__default['default']().passesAnyOf(VectorArray, pointObj).test(o);
}
function getVectorType(value) {
  return Array.isArray(value) ? 'array' : 'object';
}

function convert(value, format, keys) {
  if (getVectorType(value) === format) return value;
  return format === 'array' ? Object.values(value) : mapArrayToKeys(value, keys);
}

const validateVector = value => {
  return Object.values(value).every(v => validate(v));
};
const sanitizeVector = (value, settings, keys) => {
  for (let key in value) value[key] = sanitize(value[key], settings[key]);

  return convert(value, settings.format, keys);
};
const formatVector = (value, keys) => convert(value, 'object', keys);
function normalizeVector(_value, _settings = {}, keys) {
  const format = Array.isArray(_value) ? 'array' : 'object';
  const value = convert(_value, 'object', keys);
  const {
    settings
  } = normalizeKeyedNumberInput(value, _settings);
  return {
    value: format === 'array' ? _value : orderKeys(value, keys),
    settings: { ...settings,
      format
    }
  };
}
function getVectorPlugin(keys) {
  return {
    schema: getVectorSchema(keys),
    validate: validateVector,
    normalize: ({
      value,
      ...settings
    }) => normalizeVector(value, settings, keys),
    format: value => formatVector(value, keys),
    sanitize: (value, settings) => sanitizeVector(value, settings, keys)
  };
}

exports.ceil = ceil;
exports.clamp = clamp;
exports.debounce = debounce;
exports.getVectorPlugin = getVectorPlugin;
exports.invertedRange = invertedRange;
exports.log = log;
exports.normalizeKeyedNumberInput = normalizeKeyedNumberInput;
exports.normalizeVector = normalizeVector;
exports.orderKeys = orderKeys;
exports.pad = pad;
exports.pick = pick;
exports.props = props;
exports.range = range;
exports.sanitizeStep = sanitizeStep;
exports.warn = warn;
